/**
 * Перенаправление на страницу по умолчанию в зависимости от роли пользователя.
 * Используется как элемент маршрута "/" для авторизованных пользователей.
 */
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { getDefaultRoute } from '@/layouts/AppLayout';

const RoleRedirect: React.FC = () => {
  const user = useAuthStore((state) => state.user);
  const target = getDefaultRoute(user);
  return <Navigate to={target} replace />;
};

export default RoleRedirect;
